//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
//  -- Constants ----------------------
import {ArrowRightRounded, CheckCircleRounded} from '@mui/icons-material';
// import { Tooltip } from 'antd';
import {Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Chip, OutlinedInput, Checkbox, ListItemText, Autocomplete, TextField, Box } from '@mui/material';
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleGameDelete, handleListGame } from 'store/one_game/thunks';
import { useCurrentUser } from 'store/users/selectors';
import { useAllBook } from 'store/books/selectors';
import { useBookUnits } from 'store/booksUnits/selectors';
import { handleDuplicateByAdmin } from 'store/worksheet/thunks';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import styled from "styled-components";
import { IGameHome8 } from "utils/assets/images";
import StudyLoader from './StudyLoaader';
import { useLocation } from 'react-router-dom'
import { get } from 'lodash';
import queryString from 'query-string';
import { handleLearningModuleCount } from 'store/bingo/thunks';
const Cover = styled.div`
    width: 100%;   
    height: 230px;
    background-image: url(${p => p.src ? `'${p.src}'` : IGameHome8});
    background-size: 100%; 
    background-position: center; 
    background-repeat: no-repeat; 
`;
const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

// const settings = {
//     dots: false,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 2,
//     prevArrow: <SamplePrevArrow />,
//     nextArrow: <SampleNextArrow />,
//     responsive: [
//         {
//             breakpoint: 992,
//             settings: {
//                 slidesToShow: 3,
//             },
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             },
//         },
//     ],
// };

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function MyStudy({ bookId, pageId, userId, onGameSelect = () => { }, startGame, gameInitLoader, onEditGame = () => { }, gameEditLoader, oneStudyType, newMaskId, backToLabelStory, resource }) {
        const location = useLocation();
    const search = queryString?.parse(location.search);
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const [games, setGames] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})
    const [gameDeleteLoader, setGameDeleteLoader] = useState(false);
    const [gameDuplicateLoader, setGameDuplicateLoader] = useState(false);
    const [getDeleteItem, setGetDeleteItem] = useState();
    const [deleteModal, setDeleteModal] = useState(false)
    const [duplicateModal, setDuplicateModal] = useState(false)
    const [selectedPages, setSelectedPages] = useState([])
    const [gameToDuplicate, setGameToDuplicate] = useState(null)
    const [currentBookPages, setCurrentBookPages] = useState([]);
        const isAdmin = get(currentUser, "role") === "owe_admin";
    const showAlert = useAlert();
    const booksAllList = useAllBook();
    const bookUnitList = useBookUnits();
    
    const currentBook = booksAllList.find(book => book.id === bookId);
    const currentEbookPages = currentBook?.pages || [];
    const otherBookPages = bookUnitList.find(book => book.id === bookId)?.pages || [];

    // Generate array of objects from start to finish
    const generatePages = (start, finish) => {
      const arr = [];
      let id = 1;
      for (let i = Number(start); i <= Number(finish); i++) {
        arr.push({ id: id++, pageId: i });
      }
      return arr;
    };

    useEffect(() => {
        if (otherBookPages.length > 0) {
            const matches = otherBookPages?.find(item => {
              const startYear = parseInt(item.start, 10);
              const finishYear = parseInt(item.finish, 10);
              return pageId >= startYear && pageId <= finishYear;
            });
            if (matches) {
                const pagesArray = generatePages(matches?.start, matches?.finish);
                setCurrentBookPages(pagesArray);
            } else {
                setCurrentBookPages([]);
            }
        } else {
            setCurrentBookPages(currentEbookPages);
        }
    }, [otherBookPages, currentEbookPages]);

const loadData = async () => {
    setLoading(true);

    let data = [];

    if (isAdmin) {
        const response = await dispatch(
            handleListGame(
                userId,
                bookId,
                pageId,
                'owe_admin',
                '1study',
                backToLabelStory === 'Stories',
                resource
            )
        );
        data = response?.data || [];
    } else {
        const response = await dispatch(
            handleListGame(userId, bookId, pageId, 'my_game', '1study')
        );
        const rawData = response?.data || [];
        data = rawData.filter(item => item?.status === 'true');
    }

    let filteredGames = [];

    if (Array.isArray(data) && data.length > 0) {
        if (oneStudyType === 'flash_card') {
            filteredGames = data.filter(obj => obj.study_metadata?.type === 'flash_card');
        } else if (oneStudyType === 'quiz') {
            filteredGames = data.filter(obj => obj.study_metadata?.type === 'quiz');
        } else {
            if (isAdmin && backToLabelStory === 'Stories') {
                filteredGames = data.filter(
                    obj =>
                        obj?.games_metadata?.story?.id === search?.id &&
                        obj?.games_metadata?.story?.level === search?.level
                );
            } else {
                filteredGames = data;
            }
        }
    }

    setGames(filteredGames);
    setLoading(false);
};

    useEffect(() => {
        loadData();
    }, [pageId, oneStudyType])

    const onDeleteGame = async (gameData) => {
        setGameDeleteLoader(gameData?.game_id)
        await dispatch(handleGameDelete(userId, gameData?.game_id))
            .then((response) => {
                loadData()
            })
            .catch((error) => {
                // Handle any errors that occurred during the deleteGames action
                console.error('Error deleting game:', error);
            });
        setGameDeleteLoader(false)
    }

    const onDuplicateGame = async (gameData) => {
        setGameToDuplicate(gameData)
        setSelectedPages([])
        setDuplicateModal(true)
    }

    const handleDuplicateToPages = async () => {
        let selectedNumberMasked = [];
        if (otherBookPages?.length > 0) {
            selectedNumberMasked = selectedPages.map(pageId => {
            const maskObj = currentEbookPages.find(m => String(m.pageId) === String(pageId));
            return String(maskObj?.NumberMasked) || pageId; // fallback to pageId if not found
          });
        }
        if (selectedPages.length === 0) {
            showAlert("Please select at least one page", "warning")
            return
        }

        try {
            setGameDuplicateLoader(gameToDuplicate?.game_id)
            const duplicateData = {
                id: gameToDuplicate?.game_id,
                pages: otherBookPages?.length > 0 ? selectedNumberMasked : selectedPages,
                type: 'game',
                book_id: bookId
            }
            const duplicatedGame = await handleDuplicateByAdmin(duplicateData);
            setGameDuplicateLoader(false);
            setDuplicateModal(false);
            if (duplicatedGame?.success === true) {
                showAlert(`Study duplicated successfully to ${duplicatedGame?.mappedResults?.length} page(s)!`, "success");
            }
            if (duplicatedGame?.success === false) {
                showAlert(`Failed to duplicate study`, "error");
            }
        } catch (error) {
            showAlert("Error duplicating study", "error")
        } finally {
            setGameToDuplicate(null)
            setSelectedPages([])
        }
    }

    if (isLoading) {
        return (<StudyLoader />);
    }
    if (games.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No study available!</div>
        </div>
        )
    }
    const handleDeleteGame = async () => {
        await onDeleteGame(getDeleteItem);
        dispatch(handleLearningModuleCount({
            chapter: bookId,
            userId: currentUser.id,
            pageId: pageId,
        }));
        setDeleteModal(false);
    }
    return (
        <>
            <Slider {...settings}>
                {games.map((item, index) => {
                    const image_url = item.media_urls ? item.media_urls.image : IGameHome8
                    const isGameLoading = gameInitLoader && selectedGame.game_id === item.game_id
                    const studyMetaData = get(item, 'study_metadata', '') || {};
                    return (
                        <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                            <div className='myUnitsBnr draftImage-game frameStyle'>
                                {/* <Cover src={image_url} /> */}
                                <img
                                    src={image_url}
                                    alt=""
                                    className='imageStyle'
                                />
                                {item?.status === 'false' && (
                                    <div className='draftText-game'>Draft</div>
                                )}
                            </div>
                            <div className='myUnitsTxt'>
                                <div className='myUnitsInfo'>
                                    {/* <label>{item.display_name || 'Untitled'}</label> */}
                                    {item?.display_name && item.display_name.length > (window.innerWidth < 480 ? 40 : 20) ? (
                                        <Tooltip title={item.display_name} placement="top">
                                            {/* <label className='text-dark'>{item?.display_name.slice(0, 20) + '...'}</label> */}
                                            <label className='text-dark'>{item?.display_name.slice(0, window.innerWidth < 480 ? 40 : 20) + '...'}</label>
                                        </Tooltip>
                                    ) : (
                                        <label className='text-dark'>{item?.display_name || 'Untitled'}</label>
                                    )}
                                    <p>{item?.category?.category_name || "--"}</p>
                                    {newMaskId ? (
                                        <span>Pg. {newMaskId || '--'}</span>
                                    ) : (
                                        <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span>
                                    )}
                                    <span>{`No. of Questions: ${item?.question_length ?? 0}`}</span>
                                </div>
                                <div className='myUnitsBtns'>
                                    <a className={`study-cursor`}>{studyMetaData?.type === 'flash_card' ? "Flashcard" : "Quiz"}</a>
                                    <a onClick={() => {
                                        if (isGameLoading || gameInitLoader) {
                                            return false;
                                        }
                                        if (item?.status === 'true' && item?.question_length > 0) {
                                            setSelectedGame(item);
                                            startGame(item);
                                        }
                                    }}
                                        className={`BtnsStart ${item?.status !== 'true' || item?.question_length == 0 ? "btn-disabled-game" : ''}`}>
                                        <ArrowRightRounded />{gameInitLoader && selectedGame.game_id === item.game_id ? <Loading size={12} white /> : null} start
                                    </a>
                                    {/* </Link> */}
                                </div>
                                <div className='myUnitsBtm'><p><CheckCircleRounded /> My Creation</p></div>
                                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', gap: '10px' }} className="px-4">
                                    <div onClick={() => {
                                        onEditGame(item)
                                    }}>
                                        <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>Edit{gameEditLoader === item.game_id ? <Loading size={15} /> : null}</p>
                                    </div>
                                    {isAdmin && (
                                        <div onClick={() => {
                                            onDuplicateGame(item)
                                        }}>
                                            <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>Duplicate{gameDuplicateLoader === item.game_id ? <Loading size={15} /> : null}</p>
                                        </div>
                                    )}
                                    <div onClick={() => {
                                        setGetDeleteItem(item)
                                        // onDeleteGame(item)
                                        setDeleteModal(true);
                                    }}>
                                        {/* <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>{gameDeleteLoader === item.game_id ? <Loading size={12} /> : null} Delete </p> */}
                                        <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>Delete </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
            <DeleteModal
                message={`Do you really want to delete this study, "${getDeleteItem?.display_name ?? 'Untitled'}"`}
                deleteToggle={deleteModal}
                setDeleteToggle={setDeleteModal}
                loading={gameDeleteLoader}
                onDelete={handleDeleteGame}

            />
            
            <Dialog 
                open={duplicateModal} 
                onClose={() => setDuplicateModal(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Duplicate Study</DialogTitle>
                <DialogContent>
                    <div style={{ marginTop: '16px' }}>
                        <p style={{ marginBottom: '16px', fontSize: '14px', color: '#666' }}>
                            Select pages where you want to duplicate "{gameToDuplicate?.display_name || 'Untitled'}"
                        </p>
                        {otherBookPages.length > 0 ? (
                            <Autocomplete
                                multiple
                                options={currentBookPages}
                                getOptionLabel={(option) => option.id.toString()}
                                value={currentBookPages.filter(page => selectedPages.includes(String(page.pageId)))}
                                onChange={(event, newValue) => {
                                    setSelectedPages(newValue.map(page => String(page.pageId)));
                                }}
                                disableCloseOnSelect
                                renderOption={(props, option, { selected }) => (
                                    <li 
                                        {...props} 
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            opacity: option.pageId === pageId ? 0.5 : 1,
                                            cursor: option.pageId === pageId ? 'not-allowed' : 'pointer'
                                        }}
                                        onClick={option.pageId === pageId ? (e) => e.stopPropagation() : props.onClick}
                                    >
                                        <Checkbox
                                            checked={selected}
                                            style={{ marginRight: 8 }}
                                            disabled={option.pageId === pageId}
                                        />
                                        <span>{option.id}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Select Pages"
                                        placeholder="Search pages..."
                                    />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option.id}
                                            {...getTagProps({ index })}
                                            key={option.pageId}
                                        />
                                    ))
                                }
                            />
                        ) : (
                            <Autocomplete
                                multiple
                                options={currentBookPages}
                                getOptionLabel={(option) => option.NumberMasked || `Page ${option.pageId}`}
                                value={currentBookPages.filter(page => selectedPages.includes(page.NumberMasked || `Page ${page.pageId}`))}
                                onChange={(event, newValue) => {
                                    setSelectedPages(newValue.map(page => page.NumberMasked || `Page ${page.pageId}`));
                                }}
                                disableCloseOnSelect
                                renderOption={(props, option, { selected }) => (
                                    <li 
                                        {...props} 
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            opacity: option.pageId === pageId ? 0.5 : 1,
                                            cursor: option.pageId === pageId ? 'not-allowed' : 'pointer'
                                        }}
                                        onClick={option.pageId === pageId ? (e) => e.stopPropagation() : props.onClick}
                                    >
                                        <Checkbox
                                            checked={selected}
                                            style={{ marginRight: 8 }}
                                            disabled={option.pageId === pageId}
                                        />
                                        <span>{option.NumberMasked || `Page ${option.pageId}`}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Select Pages"
                                        placeholder="Search pages..."
                                    />
                                )}
                                renderTags={(value, getTagProps) => (
                                    <Box
                                      sx={{
                                        maxHeight: 130,         // ✅ limit height to 120px
                                        overflowY: 'auto',      // ✅ enable vertical scrolling
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 0.5,
                                      }}
                                    >
                                      {value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option.NumberMasked || `Page ${option.pageId}`}
                                            {...getTagProps({ index })}
                                            key={option.pageId}
                                        />
                                      ))}
                                    </Box>
                                  )}
                            />
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDuplicateModal(false)}>
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleDuplicateToPages}
                        variant="contained"
                        disabled={gameDuplicateLoader || selectedPages.length === 0}
                    >
                        {gameDuplicateLoader ? <Loading size={15} white /> : 'Duplicate'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}